import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import ReactLoader from 'components/Loader';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { individual_column_style } from 'assets/styles/table_custom_style';
import { individual_header_style } from 'assets/styles/table_custom_style';
import productService from 'views/CRM/Product/services/productService';

const ProductDetailsTable = ({ productId, loadingTable, onTableLoaded }) => {
  const [product, setProduct] = useState([]);

  useEffect(() => {
    const fetchProductById = async () => {
      try {
        const response = await productService.getById(productId);
        setProduct([response.data.data]);
        onTableLoaded(false);
      } catch (error) {
        console.error('Error fetching product:', error);
      }
    };

    if (productId) {
      fetchProductById();
    }
  }, [productId]);

  const columns = [
    {
      dataField: 'name',
      text: 'NOME',
      style: individual_column_style,
      headerStyle: individual_header_style,
      sort: true
    },
    {
      dataField: 'description',
      text: 'DESCRIÇÃO',
      style: individual_column_style,
      headerStyle: individual_header_style,
      sort: true
    },
    {
      dataField: 'code',
      text: 'CÓDIGO',
      style: individual_column_style,
      headerStyle: individual_header_style,
      sort: true
    },
    {
      dataField: 'basePrice',
      text: 'VALOR PADRÃO',
      style: individual_column_style,
      headerStyle: individual_header_style,
      sort: true
    }
  ];

  return (
    <>
      {loadingTable ? (
        <Container
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: '200px' }}
        >
          <ReactLoader />
        </Container>
      ) : (
        <ToolkitProvider keyField="id" data={product} columns={columns}>
          {(props) => (
            <div style={{ width: '100%', overflowX: 'auto' }}>
              <BootstrapTable
                {...props.baseProps}
                bootstrap4={true}
                bordered={false}
                wrapperClasses="table-responsive"
                classes="align-items-center table"
                style={{ width: '100%' }}
                noDataIndication="Nenhuma informação adicional encontrada"
              />
            </div>
          )}
        </ToolkitProvider>
      )}
    </>
  );
};

export default ProductDetailsTable;
